import { reduce } from "lodash"
import { useEffect } from "react"

const shareMyViewCallbacks = {}

export function addShareMyViewProps(queryProps) {
  return reduce(shareMyViewCallbacks, (result, callback) => ({
    ...result,
    ...callback(),
  }), { ...queryProps })
}

export function useShareMyViewSub(key, callback) {
  useEffect(() => {
    shareMyViewCallbacks[key] = callback

    return () => {
      delete shareMyViewCallbacks[key]
    }
  }, [key, callback])
}
